<div class="modal-header">
  <h4 class="modal-title"> {{'selectProjectReportPopup.title' | translate}}</h4>
</div>

<div class="modal-body pt-0">
  <div class="modal-body-inner overflow-xh" maxHeightOffset style="min-height: 150px">
    <table class="table table-sm table-borderless fixed-layout">
      <thead>
      <tr>
        <th class="w-50">{{'selectProjectReportPopup.template.name' | translate}}</th>
        @if (exportModel.isPrintSettingsAvailable) {
          <th class="w-50">{{'selectProjectReportPopup.properties.scale' | translate}}</th>
        }
      </tr>
      </thead>
      <tbody>
      @for (report of exportModel.reports; track report) {
        <tr>
          <td class="w-50" [ngClass]="exportModel.isPrintSettingsAvailable ? 'h-45' : ''">
            <div class="form-check checkbox">
              <input type="checkbox" class="form-check-input" id="{{report.id}}" [(ngModel)]="report.selected" (change)="onReportsChange()">
              <label for="{{ report.id }}" class="form-check-label">{{ report.name }}</label>
            </div>
          </td>
          @if (exportModel.isPrintSettingsAvailable) {
            <td class="w-50">
              @if (isReportScaleSelectionAvailable(report)) {
                <select class="form-control" [(ngModel)]="report.scale" [disabled]="!report.selected">
                  @for (item of exportModel.scaleKeys; track item) {
                    <option [ngValue]="item" [selected]="item === report.scale">{{ getScaleLabel(item) }}</option>
                  }
                </select>
              }
              @if (isReportSubtypeSelectionAvailable(report)) {
                <select class="form-control" [(ngModel)]="report.subtype" [disabled]="!report.selected">
                  @for (item of getReportSubtypeDataProvider(report); track item) {
                    <option [ngValue]="item" [selected]="item === report.subtype">{{ getReportSubtypeLabel(item) }}</option>
                  }
                </select>
              }
            </td>
          }
        </tr>
      }
      </tbody>
    </table>

    <hr [class.mt-0]="exportModel.isCSV">

    <div class="overflow-h">
      <table class="table table-sm table-borderless mb-0 fixed-layout">
        <tbody>
          @if (exportModel.isPrintSettingsAvailable) {
            <tr class="h-45">
              <td class="w-50">
                {{'selectProjectReportPopup.properties.paper_size' | translate}}:
              </td>
              <td class="w-50">
                <select class="form-control" [(ngModel)]="exportModel.paperSizeListSelected">
                  @for (item of exportModel.paperSizeKeys; track item) {
                    <option [ngValue]="item">{{getPaperSizeLabel(item)}}</option>
                  }
                </select>
              </td>
            </tr>
            <tr class="h-45">
              <td class="w-50">
                {{'selectProjectReportPopup.properties.order_numbers' | translate}}:
              </td>
              <td class="w-50">
                  <select class="form-control" [(ngModel)]="exportModel.usedNumbersGroupSelected">
                    @for (item of exportModel.orderNumbersKeys; track item) {
                      <option [ngValue]="item">{{orderNumbersLabelFn(item )}}</option>
                    }
                  </select>
              </td>
            </tr>
            <tr>
              <td class="w-50">
                {{'selectProjectReportPopup.properties.remarks' | translate}}:
              </td>
              <td class="w-50">
                <div class="form-check checkbox">
                  <input type="checkbox" class="form-check-input" id="includeRemarksCheckbox" [(ngModel)]="exportModel.includeRemarks">
                  <label for="includeRemarksCheckbox" class="form-check-label">{{'selectProjectReportPopup.properties.include_remarks' | translate}}</label>
                </div>
              </td>
            </tr>
            @if (exportModel.canSeeInternalComments) {
              <tr>
                <td class="w-50"></td>
                <td class="w-50">
                  <div class="form-check checkbox">
                    <input type="checkbox" class="form-check-input" id="includeInternalRemarksCheckbox" [(ngModel)]="exportModel.includeInternalRemarks">
                    <label for="includeInternalRemarksCheckbox" class="form-check-label">{{'selectProjectReportPopup.properties.include_internal_remarks' | translate}}</label>
                  </div>
                </td>
              </tr>
            }
          }
          <tr>
            <td class="w-50">
              {{'selectProjectReportPopup.properties.project_version' | translate}}:
            </td>
            <td class="w-50">
              <div class="form-check checkbox">
                <input type="checkbox" class="form-check-input" id="includeProjectVersionCheckbox" [(ngModel)]="exportModel.includeProjectVersion">
                <label for="includeProjectVersionCheckbox" class="form-check-label">{{'selectProjectReportPopup.properties.include_project_version' | translate}}</label>
              </div>
            </td>
          </tr>
          <tr>
            <td class="w-50">
              {{'selectProjectReportPopup.properties.document_version' | translate}}:
            </td>
            <td class="w-50">
              <div class="form-check checkbox">
                <input type="checkbox" class="form-check-input" id="includeDocumentVersionCheckbox" [(ngModel)]="exportModel.includeDocumentVersion">
                <label for="includeDocumentVersionCheckbox" class="form-check-label">{{'selectProjectReportPopup.properties.include_document_version' | translate}}</label>
              </div>
            </td>
          </tr>
          <tr>
            <td class="w-50">
              {{'selectProjectReportPopup.properties.article_number_long' | translate}}:
            </td>
            <td class="w-50">
              <div class="form-check checkbox">
                <input type="checkbox" class="form-check-input" id="includeArticleNumberLongCheckbox" [(ngModel)]="exportModel.includeArticleNumberLong">
                <label for="includeArticleNumberLongCheckbox" class="form-check-label">{{'selectProjectReportPopup.properties.include_article_number_long' | translate}}</label>
              </div>
            </td>
          </tr>
          @if (exportModel.isPrintSettingsAvailable && exportModel.isDisplayOfProjectStructureEnabled) {
            <tr>
              <td class="w-50">{{'selectProjectReportPopup.properties.id_numbers' | translate}}:</td>
              <td class="w-50">
                <div class="form-check checkbox">
                  <input type="checkbox" class="form-check-input" id="useIdsCheckbox" [(ngModel)]="exportModel.useIds">
                  <label for="useIdsCheckbox" class="form-check-label">{{'selectProjectReportPopup.properties.use_id_numbers' | translate}}</label>
                </div>
              </td>
            </tr>
          }
          @if (exportModel.canSeeInternalComments) {
            <tr>
              <td class="w-50">{{'selectProjectReportPopup.properties.configurationProperties' | translate}}:</td>
              <td class="w-50">
                <div class="form-check checkbox">
                  <input type="checkbox" class="form-check-input" id="internalProjectOptionsCheckbox" [(ngModel)]="exportModel.includeInternalOptions">
                  <label for="internalProjectOptionsCheckbox" class="form-check-label">{{'selectProjectReportPopup.properties.include_internal_remarks' | translate}}</label>
                </div>
              </td>
            </tr>
          }
          @if (exportModel.isPrintSettingsAvailable && exportModel.isDisplayOfProjectStructureEnabled) {
            <tr>
              <td class="w-50">{{'selectProjectReportPopup.properties.border' | translate}}:</td>
              <td class="w-50">
                <div class="form-check checkbox">
                  <input type="checkbox" class="form-check-input" id="isBorderVisibleCheckbox" [(ngModel)]="exportModel.isBorderVisible">
                  <label for="isBorderVisibleCheckbox" class="form-check-label">{{'selectProjectReportPopup.properties.is_border_visible' | translate}}</label>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

  </div>
</div>

<div class="modal-footer justify-content-between">
  <div class="form-check checkbox me-auto">
    <input type="checkbox" class="form-check-input" id="saveSettings" [(ngModel)]="exportModel.saveSettings">
    <label for="saveSettings" class="form-check-label">{{'selectProjectReportPopup.properties.remember' | translate}}</label>
  </div>
  <button class="btn btn-secondary btn-cancel" type="button" (click)="close()">{{'global.label.cancel' | translate}}</button>
  <button class="btn btn-primary btn-forward" [disabled]="!exportModel.nextButtonEnabled" type="button" (click)="next()">{{'global.label.next' | translate}}</button>
</div>
